import { ActionMap } from "@context/types/index";

export enum TypesAnonymous {
  Anonymous = "ANONYMOUS",
  NotAnonymous = "NOTANONYMOUS",
}

export type anonymousPayload = {
  [TypesAnonymous.Anonymous]: undefined;
  [TypesAnonymous.NotAnonymous]: undefined;
};

export type anonymousActions = ActionMap<anonymousPayload>[keyof ActionMap<
  anonymousPayload
>];
